export default __webpack_public_path__ + "static/media/socialimpact5.de0c971c.jpeg";